import { createSelector } from '@reduxjs/toolkit';

import { chatListSelector } from './chatListSelector';

export const selectChats = createSelector(chatListSelector, chatList => chatList.chats);
